<template>
  <dialogWrap
    v-model="visible"
    title="备案周期内可转移违章详情"
    width="1200px"
    :close-on-click-modal="false"
    :destory-on-close="true"
  >
    <div class="violation-detail-dialog" v-loading="loading">
      <el-table
        :data="tableData"
        border
        max-height="430"
        :span-method="tableSpanMethod"
        style="width: 100%"
      >
        <el-table-column label="车牌号" min-width="120">
          <template slot-scope="{ row }">
            {{ displayPlateNo || row.plateNo || '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="violationTime" label="违章时间" min-width="140" />
        <el-table-column prop="penaltyPoint" label="违章扣分" min-width="90" />
        <el-table-column label="处理状态" min-width="110">
          <template slot-scope="{ row }">
            <span :class="statusClass(row.handleState)">{{ handleStateText(row.handleState, row.handleStateName) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="违章罚款" min-width="100">
          <template slot-scope="{ row }">
            {{ amountText(row.penaltyAmount) }}
          </template>
        </el-table-column>
        <el-table-column label="缴款状态" min-width="110">
          <template slot-scope="{ row }">
            <span :class="statusClass(row.paymentState)">{{ paymentStateText(row.paymentState, row.paymentStateName) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="place" label="违章地点" min-width="220" show-overflow-tooltip />
        <el-table-column prop="content" label="违章行为" min-width="200" show-overflow-tooltip />
      </el-table>

      <div class="summary-bar">
        <span>违章总数：<em>{{ summary.total }}</em> 条</span>
        <span>累计扣分：<em>{{ summary.points }}</em> 分</span>
        <span>累计罚款：<em>{{ summary.amount }}</em> 元</span>
      </div>
    </div>
    <template slot="footer">
      <el-button type="primary" @click="visible = false">关闭</el-button>
    </template>
  </dialogWrap>
</template>

<script setup>
import { computed, ref } from 'vue'
import { queryViolationInfo } from '@/api/domain/carsService.js'
import { Message } from 'element-ui'

const visible = ref(false)
const loading = ref(false)
const tableData = ref([])
const displayPlateNo = ref('')
const summaryData = ref({
  totalCount: 0,
  penaltyTotalPoint: 0,
  penaltyTotalAmount: 0,
})

const handleStateMap = {
  0: '未处理',
  1: '已处理',
  3: '未处理已人车分离',
}

const paymentStateMap = {
  0: '未缴款',
  1: '已缴款',
  9: '无需交款',
}

const summary = computed(() => {
  const total = Number(summaryData.value.totalCount || 0)
  const points = Number(summaryData.value.penaltyTotalPoint || 0)
  const amount = Number(summaryData.value.penaltyTotalAmount || 0)
  return {
    total,
    points,
    amount: amount.toFixed(2).replace(/\.00$/, ''),
  }
})

const amountText = (amount) => `${Number(amount || 0)} 元`

const handleStateText = (state, stateName) => stateName || handleStateMap[Number(state)] || '--'
const paymentStateText = (state, stateName) => stateName || paymentStateMap[Number(state)] || '--'

const statusClass = (state) => (Number(state) === 0 ? 'status-red' : '')

const tableSpanMethod = ({ rowIndex, columnIndex }) => {
  // 仅合并第一列（车牌号）
  if (columnIndex === 0) {
    if (rowIndex === 0) {
      return {
        rowspan: tableData.value.length || 1,
        colspan: 1,
      }
    }
    return {
      rowspan: 0,
      colspan: 0,
    }
  }
  return {
    rowspan: 1,
    colspan: 1,
  }
}

const show = async (row) => {
  visible.value = true
  tableData.value = []
  displayPlateNo.value = row.plateNo || ''
  summaryData.value = {
    totalCount: 0,
    penaltyTotalPoint: 0,
    penaltyTotalAmount: 0,
  }
  loading.value = true
  try {
    const { code, data, msg } = await queryViolationInfo({
      plateNo: row.plateNo,
      contractStartTime: row.contractStartTime,
      contractEndTime: row.contractEndTime,
    })
    if (code === 1) {
      const list = data?.violationList || []
      tableData.value = Array.isArray(list) ? list : []
      summaryData.value = {
        totalCount: data?.totalCount || 0,
        penaltyTotalPoint: data?.penaltyTotalPoint || 0,
        penaltyTotalAmount: data?.penaltyTotalAmount || 0,
      }
    } else {
      Message.error(msg || '查询违章详情失败')
    }
  } catch (error) {
    Message.error(error?.msg || '查询违章详情失败')
  } finally {
    loading.value = false
  }
}

defineExpose({
  show,
})
</script>

<style scoped lang="scss">
.violation-detail-dialog {
  .status-red {
    color: #ff4d4f;
  }

  .summary-bar {
    margin-top: 14px;
    padding: 10px 14px;
    border-radius: 8px;
    background: #f7f8fa;
    font-size: 18px;
    display: flex;
    align-items: center;
    gap: 32px;

    em {
      color: #1677ff;
      font-style: normal;
      font-weight: 600;
    }
  }
}
</style>
